<template>
    <button
        type="button"
        :class="classes_button"
        @click="clickButton"
        :title="title"
        :disabled="disabled"
    >
        <div :class="classes_text">{{ text }}</div>
        <button-loader :show="spinner" />
    </button>
</template>


<script>
    export default {
        props: {
            "type": {
                type: String,
                validator: (val) => ['primary', 'secondary', 'tertiary'].includes(val),
                default: 'primary',
            },
            "title": {
                type: String,
                default: '',
            },
            "text": {
                type: String,
                default: '',
            },
            "click": {
                type: Function,
                default: () => { return; },
            },
            "spinner": {
                type: Boolean,
                default: false,
            },
            "additionalDisable": {
                type: Boolean,
                default: false,
            },
            "btnClasses": {
                type: Array,
            },
        },
        computed: {
            classes_button() {
                return this.btnClasses || [
                    "btn",
                    "btn--"+this.type,
                ];
            },
            classes_text() {
                return this.spinner ? [
                    "btn__hide-text",
                    "btn__hide-text--"+this.type,
                ] : [];
            },
            disabled() {
                return this.spinner || this.additionalDisable;
            },
        },

        methods: {
            clickButton(event) {
                event.preventDefault();
                this.click(event);
            },
        },
    }
</script>
